import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminLayoutComponent } from './components/layout/admin-layout/admin-layout.component';
import { AdminNavbarComponent } from '../admin/shared/components/admin-navbar/admin-navbar.component';
import { AdminFooterComponent } from '../admin/shared/components/admin-footer/admin-footer.component';
import { AdminSidebarComponent } from '../admin/shared/components/admin-sidebar/admin-sidebar.component';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { HomeLayoutComponent } from './components/layout/home-layout/home-layout.component';
import { NavbarComponent } from '../home/shared/navbar/navbar.component';
import { FooterComponent } from '../home/shared/footer/footer.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
    declarations: [
        AdminLayoutComponent,
        AdminNavbarComponent,
        AdminFooterComponent,
        AdminSidebarComponent,
        HomeLayoutComponent,
        NavbarComponent,
        FooterComponent
    ],
    imports: [
        CommonModule,
        RouterOutlet,
        BrowserModule,
        RouterLink,
        PerfectScrollbarModule,
        CollapseModule,
        RouterLinkActive,
        BsDropdownModule
    ]
})
export class SharedModule {}
